import { createContext } from 'react';
import { AvatarContextModel } from './avatar.model';

export const AvatarContext = createContext<AvatarContextModel>(null as any);
